export default [
  {
    path: 'M932.317 567.767l-47.212-145.306-93.573-287.998c-4.813-14.817-25.777-14.817-30.591 0L667.36 422.46H356.628l-93.577-287.998c-4.813-14.817-25.776-14.817-30.593 0L138.885 422.46l-47.21 145.31a32.166 32.166 0 0 0 11.683 35.963l408.628 296.89 408.631-296.888a32.17 32.17 0 0 0 11.684-35.965',
    fill: '#FC6D26',
  },
  { path: 'M512.002 900.628l155.365-478.17H356.635z', fill: '#E24329' },
  { path: 'M512.004 900.628L356.64 422.472H138.902z', fill: '#FC6D26' },
  {
    path: 'M138.891 422.466l-47.214 145.31a32.164 32.164 0 0 0 11.686 35.962l408.629 296.89z',
    fill: '#FCA326',
  },
  {
    path: 'M138.893 422.46h217.738L263.053 134.46c-4.812-14.819-25.778-14.819-30.59 0z',
    fill: '#E24329',
  },
  { path: 'M512.002 900.628l155.365-478.154h217.738z', fill: '#FC6D26' },
  {
    path: 'M885.115 422.466l47.214 145.31a32.164 32.164 0 0 1-11.685 35.962l-408.63 296.89z',
    fill: '#FCA326',
  },
  {
    path: 'M885.096 422.46H667.361l93.577-287.999c4.815-14.819 25.779-14.819 30.591 0z',
    fill: '#E24329',
  },
]
